import type { SingleIconProps } from "./icon"

const CloseIcon = (props: SingleIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8184 3L3.00043 18.818L4.41343 20.232L11.6282 13.0177L18.7712 20.1608L20.1862 18.7468L13.0427 11.6033L20.2324 4.414L18.8184 3ZM3.02513 4.414L4.43913 3L9.83413 8.395L8.42113 9.809L3.02513 4.414Z"
        fill={props.fill ?? "#081F42"}
      />
    </svg>
  )
}

export { CloseIcon }
